<template>
  <div class="ios-overlay" @click.self="$emit('close')">
    <div class="ios-modal">
      <h3>Install StumptheSpread</h3>
      <p class="ios-subtitle">Push notifications require the app to be installed on your home screen.</p>

      <div class="ios-steps">
        <div class="ios-step">
          <div class="ios-step-number">1</div>
          <div class="ios-step-content">
            <p>Tap the <strong>Share</strong> button in Safari</p>
            <div class="ios-share-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#e94560" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/>
                <polyline points="16 6 12 2 8 6"/>
                <line x1="12" y1="2" x2="12" y2="15"/>
              </svg>
            </div>
          </div>
        </div>

        <div class="ios-step">
          <div class="ios-step-number">2</div>
          <div class="ios-step-content">
            <p>Scroll down and tap <strong>"Add to Home Screen"</strong></p>
          </div>
        </div>

        <div class="ios-step">
          <div class="ios-step-number">3</div>
          <div class="ios-step-content">
            <p>Tap <strong>"Add"</strong> in the top right</p>
          </div>
        </div>

        <div class="ios-step">
          <div class="ios-step-number">4</div>
          <div class="ios-step-content">
            <p>Open <strong>StumptheSpread</strong> from your home screen</p>
          </div>
        </div>

        <div class="ios-step">
          <div class="ios-step-number">5</div>
          <div class="ios-step-content">
            <p>Come back here to <strong>enable notifications</strong></p>
          </div>
        </div>
      </div>

      <div class="ios-arrow-container">
        <div class="ios-arrow">&#8595;</div>
      </div>

      <button type="button" class="ios-dismiss" @click="$emit('close')">Got it</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IOSInstallGuide'
}
</script>

<style scoped>
.ios-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.ios-modal {
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  max-width: 340px;
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
}

.ios-modal h3 {
  margin: 0 0 8px;
  font-size: 20px;
  color: #1a1a2e;
  text-align: center;
}

.ios-subtitle {
  text-align: center;
  color: #666;
  font-size: 14px;
  margin-bottom: 20px;
}

.ios-steps {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.ios-step {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.ios-step-number {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #e94560;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 14px;
  flex-shrink: 0;
}

.ios-step-content {
  flex: 1;
}

.ios-step-content p {
  margin: 4px 0 0;
  font-size: 14px;
  color: #333;
  line-height: 1.4;
}

.ios-share-icon {
  display: inline-block;
  margin-top: 4px;
}

.ios-arrow-container {
  text-align: center;
  margin-top: 20px;
}

.ios-arrow {
  font-size: 32px;
  color: #e94560;
  animation: bounce 1.5s infinite;
  display: inline-block;
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(10px); }
}

.ios-dismiss {
  width: 100%;
  margin-top: 16px;
  padding: 12px;
  font-size: 16px;
  font-weight: bold;
  line-height: normal;
  height: auto;
  cursor: pointer;
  border: none;
  border-radius: 8px;
  background: #e94560;
  color: #fff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// IOSInstallGuide.vue?a7bf0e42